import React, { useContext, useEffect, useState } from 'react';
import { post } from '../utils/fetcher';
import { Eye, ArrowBigUp, ArrowBigDown } from "lucide-react";
import Mintag from '../components/Mintag';
import AppContext from '../Context/AppContext';
import GeoStat from '../components/GeoStat';
const InfoCardItem = ({ item,item_i }) => {
    const {setSideComponent} = useContext(AppContext)
    const [listIp, setListIp] = useState([]);
    const callInfoIp = async () => {
        setSideComponent(<GeoStat/>)

        const { infoUser } = item;
        const response = await post("/info/get_ip", { all_ip: infoUser });

        
        if(response?.result?.length > 0){
                setListIp(response.result)
        }
    }
    useEffect(()=>{
        if(listIp?.length > 0){
            setSideComponent(<GeoStat data={listIp}/>)
        }
    },[listIp])
    useEffect(() => {
        setListIp([])
    }, [item])
    return (
        <button onClick={() => callInfoIp()} className='df aifs w100 cp '>
            <img className='img-item-stat mr2' src={item.img}></img>
            <div className='flex1 df fdc'>
                <div className='df aic jcsb '>
                    <p className='fr fs14 cw'>{item.title}</p>
                    <p className='df aic cw fb'> <span className='mr1'><Eye size={15} color='#fff' /></span> {item.viewers}</p>
                </div>
                <div className='df aic jcsb mt1'>
                    <div className='df aic'>
                        {item?.percentVersion?.length > 0 && item.percentVersion.map((ver, ver_i) => (
                            <div className='fr cw df aic mr1' key={ver_i + "_version" + item_i}>
                                <p className='fl fs10 mr1'>{ver.name}</p>
                                <Mintag label={ver.percent} />
                            </div>
                        ))}
                    </div>
                    {item.changement !== 0 && item.changement !== null && (
                        <div className={`df aic `}>
                            <div className='mr1'>
                                {item.changement > 0 ? <ArrowBigUp size={18} color='#15992f' /> : <ArrowBigDown size={18} color='#f71717' />}
                            </div>
                            <p className='cw fr'>
                                {item.changement}
                            </p>
                        </div>
                    )}

                </div>
            </div>
        </button>
    );
};

export default InfoCardItem;